import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-md-4" }
const _hoisted_3 = { class: "card mb-25 border-0 rounded-0 bg-white letter-spacing project-card" }
const _hoisted_4 = { class: "card-body p-20 p-md-25 p-lg-30" }
const _hoisted_5 = { class: "info ps-0 mb-15 mb-md-20 mb-lg-30 list-unstyled" }
const _hoisted_6 = { class: "text-secondary fs-md-15 fs-md-16 fw-semibold" }
const _hoisted_7 = { class: "text-secondary fs-md-15 fs-md-16 fw-semibold" }
const _hoisted_8 = { class: "text-secondary fs-md-15 fs-md-16 fw-semibold" }
const _hoisted_9 = { class: "col-md-8" }
const _hoisted_10 = { class: "card mb-25 border-0 rounded-0 bg-white letter-spacing project-card" }
const _hoisted_11 = { class: "card-body p-20 p-md-25 p-lg-30" }
const _hoisted_12 = { class: "info ps-0 mb-15 mb-md-20 mb-lg-30 list-unstyled" }
const _hoisted_13 = { class: "fs-md-15 fs-md-16 fw-semibold" }
const _hoisted_14 = { class: "fs-md-15 fs-md-16 fw-semibold" }
const _hoisted_15 = { class: "fs-md-15 fs-md-16 fw-semibold" }
const _hoisted_16 = { class: "fs-md-15 fs-md-16 fw-semibold" }
const _hoisted_17 = { class: "fs-md-15 fs-md-16 fw-semibold" }
const _hoisted_18 = { class: "fs-md-15 fs-md-16 fw-semibold" }
const _hoisted_19 = { class: "fs-md-15 fs-md-16 fw-semibold" }
const _hoisted_20 = { class: "fs-md-15 fs-md-16 fw-semibold" }
const _hoisted_21 = {
  key: 0,
  class: "fs-md-15 fs-md-16 fw-semibold"
}
const _hoisted_22 = { class: "col-12 mb-30" }
const _hoisted_23 = {
  key: 0,
  class: "table-responsive"
}
const _hoisted_24 = { class: "table text-nowrap align-middle mb-0" }
const _hoisted_25 = { class: "shadow-none lh-1 fw-bold ps-0" }
const _hoisted_26 = ["src"]
const _hoisted_27 = { class: "shadow-none lh-1 fw-medium" }
const _hoisted_28 = { class: "shadow-none lh-1 fw-medium text-body-tertiary" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _cache[3] || (_cache[3] = _createElementVNode("div", { class: "mb-12 mb-md-15 mb-lg-20 d-flex justify-content-between align-items-center" }, [
            _createElementVNode("div", { class: "title d-flex align-items-center" }, [
              _createElementVNode("div", { class: "ms-15" }, [
                _createElementVNode("h5", { class: "mb-0 fs-14 fs-md-16 fs-lg-18 fw-bold mt-8 mt-md-10" }, " Information Client ")
              ])
            ])
          ], -1)),
          _createElementVNode("ul", _hoisted_5, [
            _createElementVNode("li", _hoisted_6, [
              _cache[0] || (_cache[0] = _createElementVNode("span", { class: "text-muted fs-12 fs-md-13 text-uppercase fw-medium d-inline-block" }, "Magasin : ", -1)),
              _createTextVNode(" " + _toDisplayString($setup.colis.magasin_name), 1)
            ]),
            _createElementVNode("li", _hoisted_7, [
              _cache[1] || (_cache[1] = _createElementVNode("span", { class: "text-muted fs-12 fs-md-13 text-uppercase fw-medium d-inline-block" }, "Client : ", -1)),
              _createTextVNode(" " + _toDisplayString($setup.colis.client_name), 1)
            ]),
            _createElementVNode("li", _hoisted_8, [
              _cache[2] || (_cache[2] = _createElementVNode("span", { class: "text-muted fs-12 fs-md-13 text-uppercase fw-medium d-inline-block" }, "Téléphone : ", -1)),
              _createTextVNode(" " + _toDisplayString($setup.colis.customer_phone), 1)
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", _hoisted_11, [
          _cache[13] || (_cache[13] = _createElementVNode("div", { class: "mb-12 mb-md-15 mb-lg-20 d-flex justify-content-between align-items-center" }, [
            _createElementVNode("div", { class: "title d-flex align-items-center" }, [
              _createElementVNode("div", { class: "ms-15" }, [
                _createElementVNode("h5", { class: "mb-0 fs-14 fs-md-16 fs-lg-18 fw-bold mt-8 mt-md-10" }, " Informations Colis ")
              ])
            ])
          ], -1)),
          _createElementVNode("ul", _hoisted_12, [
            _createElementVNode("li", _hoisted_13, [
              _cache[4] || (_cache[4] = _createElementVNode("span", { class: "text-muted fs-12 fs-md-13 text-uppercase fw-medium d-inline-block" }, "Code d'envoi : ", -1)),
              _createTextVNode(" " + _toDisplayString($setup.colis.code), 1)
            ]),
            _createElementVNode("li", _hoisted_14, [
              _cache[5] || (_cache[5] = _createElementVNode("span", { class: "text-muted fs-12 fs-md-13 text-uppercase fw-medium d-inline-block" }, "Destinataire : ", -1)),
              _createTextVNode(" " + _toDisplayString($setup.colis.receiver), 1)
            ]),
            _createElementVNode("li", _hoisted_15, [
              _cache[6] || (_cache[6] = _createElementVNode("span", { class: "text-muted fs-12 fs-md-13 text-uppercase fw-medium d-inline-block" }, "Téléphone : ", -1)),
              _createTextVNode(" " + _toDisplayString($setup.colis.phone), 1)
            ]),
            _createElementVNode("li", _hoisted_16, [
              _cache[7] || (_cache[7] = _createElementVNode("span", { class: "text-muted fs-12 fs-md-13 text-uppercase fw-medium d-inline-block" }, "Ville : ", -1)),
              _createTextVNode(" " + _toDisplayString($setup.colis.city_name), 1)
            ]),
            _createElementVNode("li", _hoisted_17, [
              _cache[8] || (_cache[8] = _createElementVNode("span", { class: "text-muted fs-12 fs-md-13 text-uppercase fw-medium d-inline-block" }, "Adresse : ", -1)),
              _createTextVNode(" " + _toDisplayString($setup.colis.adresse) + " ", 1),
              ($setup.colis.quartier)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createTextVNode(" - " + _toDisplayString($setup.colis.quartier?.name), 1)
                  ], 64))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("li", _hoisted_18, [
              _cache[9] || (_cache[9] = _createElementVNode("span", { class: "text-muted fs-12 fs-md-13 text-uppercase fw-medium d-inline-block" }, "Commentaire : ", -1)),
              _createTextVNode(" " + _toDisplayString($setup.colis.note), 1)
            ]),
            _createElementVNode("li", _hoisted_19, [
              _cache[10] || (_cache[10] = _createElementVNode("span", { class: "text-muted fs-12 fs-md-13 text-uppercase fw-medium d-inline-block" }, "Nature Produit : ", -1)),
              _createTextVNode(" " + _toDisplayString($setup.colis.product_nature), 1)
            ]),
            _createElementVNode("li", _hoisted_20, [
              _cache[11] || (_cache[11] = _createElementVNode("span", { class: "text-muted fs-12 fs-md-13 text-uppercase fw-medium d-inline-block" }, "Crbt : ", -1)),
              _createTextVNode(" " + _toDisplayString($setup.colis.price) + " " + _toDisplayString(_ctx.$devis), 1)
            ]),
            ($setup.colis.from_stock === 1)
              ? (_openBlock(), _createElementBlock("li", _hoisted_21, _cache[12] || (_cache[12] = [
                  _createElementVNode("h6", null, [
                    _createElementVNode("i", { class: "flaticon-shopping-cart-2" }),
                    _createTextVNode("Colis de Stock")
                  ], -1)
                ])))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_22, [
      ($setup.colis.products)
        ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
            _createElementVNode("table", _hoisted_24, [
              _cache[17] || (_cache[17] = _createElementVNode("thead", null, [
                _createElementVNode("tr", null, [
                  _createElementVNode("th", {
                    scope: "col",
                    class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 ps-0"
                  }),
                  _createElementVNode("th", {
                    scope: "col",
                    class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                  }, " Produit "),
                  _createElementVNode("th", {
                    scope: "col",
                    class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                  }, " Informations ")
                ])
              ], -1)),
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.colis.products, (product, index) => {
                  return (_openBlock(), _createElementBlock("tr", { key: index }, [
                    _createElementVNode("th", _hoisted_25, [
                      (product.product_pic)
                        ? (_openBlock(), _createElementBlock("img", {
                            key: 0,
                            src: 
                      product.product_pic ||
                      require('@/assets/images/NoImage.png')
                    ,
                            width: "60",
                            height: "60",
                            class: ""
                          }, null, 8, _hoisted_26))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("td", _hoisted_27, [
                      _createTextVNode(_toDisplayString(product.product_name), 1),
                      _cache[14] || (_cache[14] = _createElementVNode("br", null, null, -1)),
                      _createElementVNode("b", null, _toDisplayString(product.variant_name) + " - " + _toDisplayString(product.variant_ref), 1)
                    ]),
                    _createElementVNode("td", _hoisted_28, [
                      _createElementVNode("span", null, [
                        _cache[15] || (_cache[15] = _createElementVNode("b", null, "Quantité : ", -1)),
                        _createTextVNode(_toDisplayString(product.qnty), 1)
                      ]),
                      _createElementVNode("span", null, [
                        _cache[16] || (_cache[16] = _createElementVNode("b", null, "Date : ", -1)),
                        _createTextVNode(_toDisplayString($setup.getDate(product.created_at)), 1)
                      ])
                    ])
                  ]))
                }), 128))
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}